import Link from 'next/link';

import { LocationItemStoryblok } from '../../types/generated-storyblok';

export const ContentLocation = ({ blok }: { blok: LocationItemStoryblok }) => (
  <Link
    className="group flex gap-3 py-4"
    href={blok.url.cached_url!}
    target="_blank"
  >
    <span className="flex h-5 w-8 shrink-0 items-center justify-center text-center text-active-4">
      {blok.id}
    </span>
    <span className="flex w-full flex-col">
      <span className="font-bold">{blok.title}</span>
      <span>{blok.description}</span>
    </span>
  </Link>
);
